<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn
							icon
							@click="
								$inertia.visit($route('central.outlets.index'))
							"
							><v-icon>mdi-arrow-left</v-icon></v-btn
						>
						{{ $t("title.create_outlet") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<ValidationProvider
							name="opening_time"
							v-slot="{ errors }"
						>
							<v-select
								:items="tenants"
								v-model="item.tenant_id"
								item-value="id"
								item-text="name"
								:label="$t('Select Tenant')"
								:error-messages="errors"
								filled
								class="pa-3"
							></v-select>
						</ValidationProvider>
						<form-outlet
							v-model="item"
							:locations="locations"
						></form-outlet>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>
<script>
export default {
	props: ["locations", "tenants"],
	data() {
		return {
			item: this.$inertia.form({
				tenant_id: null,
				name: {
					en: null,
					km: null,
					fr: null,
					zh: null,
				},
				phone: null,
				email: null,
				address: null,
				location_id: null,
				description: {
					en: null,
					km: null,
					fr: null,
					zh: null,
				},
				image: {},
				settings: {},
				latitude: 11.562454466918203,
				longitude: 104.92219185180667,
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("central.outlets.store"));
		},
	},
};
</script>
